import { createPostJSON } from "../helper/customs";
import { accumalateMessage } from "./messaging.api";
const mockURL = "https://wa.ssc.gov.jo/api/chatbot";

const sendMessage = (data) => {
  // accumalateMessage({
  //   userId:data.user_id
  // });
  return fetch(`${mockURL}`, createPostJSON(data))
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export { sendMessage };
